import React, { useEffect } from 'react';
import { useHighlightOfferExperiment } from 'src/hooks/experiments';
import { IExperimentProps, IProductNativeAdExperimentProps } from './types';

const mobile = '103';
const headphones = '148';
const gameConsoles = '401';
const smartWatches = '1808';
const categoryIds = [mobile, headphones, gameConsoles, smartWatches];

const HighlightOfferExperiment: React.FC<IProductNativeAdExperimentProps> = props => {
  return props.categoryId && categoryIds.indexOf(props.categoryId) > -1 ? (
    <Experiment setShowHighlightedOffers={props.setShowHighlightedOffers} />
  ) : null;
};

const Experiment: React.FC<IExperimentProps> = props => {
  const experiment = useHighlightOfferExperiment();
  useEffect(() => {
    props.setShowHighlightedOffers(experiment);
  }, [experiment, props]);

  return null;
};

export default HighlightOfferExperiment;
